var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tasks-this-week'),_c('next-tasks'),_c('tasks-pending-config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }